export enum CommandPaletteSearchTypes {
  PIPE = 'pipe',
  DATASET = 'dataset',
  SYSTEM = 'system',
  GLOBAL = 'global',
  ALL = '',
}

export type CommandPaletteSearchRendererArgs = {
  id: string;
  name?: string;
  type: CommandPaletteSearchTypes;
};

export type Needle = {
  item: { id: string; name?: string };
  keyMaker: (item: string) => string;
  renderer: (args: CommandPaletteSearchRendererArgs) => React.ReactNode;
  type: CommandPaletteSearchTypes;
};

export type NewEntityNeedle = {
  item: { id: string; name?: string };
  onActivate?: () => void;
  renderer: () => React.JSX.Element;
  keyMaker: (_id: string) => string;
  type: CommandPaletteSearchTypes;
};
